//@flow

import styled from 'styled-components';
import { FlexRow, FlexColumn } from 'styles/Layout';
import { AdvisorPrimaryButton } from 'styles/Buttons';

export const Wrapper = styled(FlexRow)`
  flex-wrap: wrap;
  margin: auto 0;
`;

export const Container = styled(FlexColumn)`
  flex-basis: 0;
  flex-grow: 1;
`;

export const Card = styled(FlexColumn)`
  position: relative;
  width: 350px;
  min-height: 300px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.18);
  margin: 10px;
`;

export const TextStep = styled.div`
  font-size: 30px;
  color: ${props => (props.stepProcess ? '#748796' : '#C0BFBF')};
  margin-left: 23px;
  font-weight: ${props => (props.selectedStep ? 'bold' : 'normal')};
`;

export const PlaceTypeInput = styled.span`
  position: absolute;
  top: 0;
  right: 18px;
  height: 35px;
  color: #9b9b9b;
  font-size: 14px;
  line-height: 35px;
  z-index: 2;
`;

export const SubtitleInput = styled.div`
  min-height: 17px;
  font-size: 14px;
  line-height: 17px;
  color: #9b9b9b;
  max-width: 300px;
  text-align: left;
`;

export const SectionContainer = styled(FlexColumn)`
  margin-bottom: 10px;
`;

export const SectionTitle = styled.h2`
  min-height: 19px;
  color: #707070;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  margin: ${props => (props.margin ? props.margin : '0 0 20px 0')};
`;

export const SubmitButton = styled(AdvisorPrimaryButton)`
  width: 159px;
  margin-top: 13px;
`;

export const CardBody = styled(FlexColumn)`
  width: 100%;
  border-radius: 4px;
  background-color: #ffffff;
  padding: ${props => (props.padding ? props.padding : '10px 25px 0 25px')};
  overflow-y: ${props => (props.overflowy ? props.overflowy : 'auto')};
  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: #eaeaea;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 15px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const IconImg = styled.img`
  width: ${props => props.width};
  height: ${props => props.height};
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  ${props => props.className}
`;

export const InfoTitle = styled.div`
  color: #9f9f9f;
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.isBold};
  line-height: 26px;
  text-align: ${props => props.isCenter};
  margin-top: ${props => props.marginTop};
  margin-bottom: ${props => props.marginBottom};
  margin-right: ${props => props.marginRight};
  margin-left: ${props => props.marginLeft};
  cursor: ${props => props.cursor};
`;
